<template>
  <section class="ew-height">
    <navbar-dashboard name="Seleccionar paquetería" v-if="!isLoadingShippingOptions"></navbar-dashboard>
    <div v-if="isLoadingShippingOptions" class="ew-loading-indicator">
      <div class="ew-loading-indicator__inner">
        <img src="@/assets/images/loading.gif" alt="Cargando...">
        <p class="ew-loading-indicator__text">Espere un momento, estamos obteniendo los mejores precios para tu paquete</p>
      </div>
    </div>

    <section class="ew-page__body" v-if="!isLoadingShippingOptions">
      <div class="ew-step-layout">
        <div class="ew-step-layout__main">
          <div class="ew-carrier-list">
            <div class="ew-carrier-card" v-for="(so, i) in visibleShipmentOptios" v-bind:key="i">
              <div class="ew-carrier-card__logo">
                <img :src="so.carrier_logo_url_svg" alt="">
              </div>

              <div class="ew-carrier-card__info">
                <div class="ew-carrier-card__name">{{ so.carrier_service_name }}</div>
                <div class="ew-carrier-card__transit" :class="{ 'ew-area-remote': so.is_remote }">{{ getTransitInterval(so.total_transit_days, so.carrier_service_name, so.is_remote) }}</div>
                <div class="ew-carrier-card__note">Es necesario imprimir guías *</div>
                <div class="ew-carrier-card__note--warning" v-if="so.note">{{ so.note }}</div>
              </div>

              <div class="ew-carrier-card__price">
                <p class="ew-carrier-card__amount">{{ so.currency }} {{ so.total_amount }}</p>
                <button type="button" class="ew-carrier-card__detail-btn" :id="'detail-' + i">Ver desglose</button>
                <b-popover :target="'detail-' + i" placement="top" title="Desglose de precio" triggers="click blur">
                  <div class="ew-price-breakdown">
                    <div class="ew-price-breakdown__row" v-for="(service, k) in so.services" v-bind:key="k">
                      <span>{{ service.service_name }}:</span>
                      <span>MXN {{ service.price }}</span>
                    </div>
                    <div class="ew-price-breakdown__total">
                      <span>Total:</span>
                      <span>MXN {{ so.total_amount }}</span>
                    </div>
                  </div>
                </b-popover>
              </div>

              <button type="button" class="ew-btn-primary" @click="triggerPrimaryAction(selectedShippingOption=i)">{{ primaryActionText || 'Enviar' }}</button>
            </div>

            <div class="ew-empty" v-if="visibleShipmentOptios.length === 0">
              <ph-icon name="package" />
              <p class="ew-empty__title">Ningún servicio disponible</p>
              <p class="ew-empty__text">Intenta ajustar los filtros o vuelve más tarde.</p>
            </div>

            <div class="ew-wizard__actions ew-wizard__actions--end">
              <button type="button" class="ew-btn-outline" @click="triggerSecondaryAction">{{ secondaryActionText || 'Regresar' }}</button>
            </div>
          </div>
        </div>

        <aside class="ew-card ew-filters-aside">
          <p class="ew-card-title">Proveedor</p>
          <label class="ew-filter-check" v-for="c in availableCarriers" v-bind:key="c.label">
            <input type="checkbox" :value="c.value" v-model="visibleCarriers">
            <span>{{ c.label }}</span>
          </label>

          <p class="ew-card-title ew-filters-aside__title--spaced">Velocidad de envío</p>
          <label class="ew-filter-check">
            <input type="checkbox" value="1-2" v-model="visibleShipmentSpeed">
            <span>Día siguiente</span>
          </label>
          <label class="ew-filter-check">
            <input type="checkbox" value="1-2" v-model="visibleShipmentSpeed">
            <span>1 a 2 días</span>
          </label>
          <label class="ew-filter-check">
            <input type="checkbox" value="2-4" v-model="visibleShipmentSpeed">
            <span>2 a 4 días</span>
          </label>
          <label class="ew-filter-check">
            <input type="checkbox" value="2-5" v-model="visibleShipmentSpeed">
            <span>2 a 5 días</span>
          </label>
        </aside>
      </div>
    </section>
  </section>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import Navbar from './Header/Navbar'
import PhIcon from './icons/PhIcon'
export default {
  name: 'ServiceProviderSelector',
  props: {
    origin: Object,
    destination: Object,
    parcels: Array,
    primaryActionText: String,
    secondaryActionText: String,
    insurance: Object,
    packageType: String
  },
  data () {
    return {
      selectedShippingOption: -1,
      availableCarriers: [
        {
          label: 'DHL',
          value: 'dhl'
        },
        {
          label: 'Redpack',
          value: 'redpack'
        },
        {
          label: 'FedEx',
          value: 'fedex'
        }
      ],
      visibleShipmentSpeed: [],
      visibleCarriers: [],
      visibleShipmentOptios: [],

      requestBody: {
        origin_direction: {
          country_code: '',
          postal_code: '',
          city: '',
          suburb: ''
        },

        parcels: [
          {
            weight: '',
            height: '',
            depth: '',
            width: ''
          }
        ],
        destination_direction: {
          country_code: '',
          postal_code: '',
          city: '',
          suburb: ''
        }
      }
    }
  },
  watch: {
    visibleCarriers: function (oldValue, newValue) {
      let vc = []
      let vss = []

      if (!this.visibleCarriers.length) {
        vc = this.availableCarriers.map(c => c.value)
      } else {
        vc = this.visibleCarriers
      }

      if (!this.visibleShipmentSpeed.length) {
        vss = ['0-1', '1-2','2-4', '2-5']
      } else {
        vss = this.visibleShipmentSpeed
      }
      this.filter(vc, vss)
    },

    visibleShipmentSpeed: function (oldValue, newValue) {
      let vc = []
      let vss = []
      console.log("visibleShipmentSpeed: ",oldValue, newValue)
      if (!this.visibleCarriers.length) {
        vc = this.availableCarriers.map(c => c.value)
      } else {
        vc = this.visibleCarriers
      }

      if (!this.visibleShipmentSpeed.length) {
        vss = ['0-1', '1-2','2-4', '2-5']
      } else {
        vss = this.visibleShipmentSpeed
      }
      this.filter(vc, vss)
    },

    shippingOptions: function (oldValue, newValue) {
      if (newValue.length) {
        this.visibleShipmentOptions = newValue
      } else {
        this.visibleShipmentOptions = this.shippingOptions
      }
    }
  },
  methods: {
    selectedShippingOptionEvent(index){
      if (this.selectedShippingOption === index) {
        this.selectedShippingOption = -1
      } else {
        this.selectedShippingOption = index
        this.setSelectedShippingOption(this.shippingOptions[this.selectedShippingOption])  
      }
    },
    ...mapActions(['quoting']),
    ...mapMutations([
      'setQuotingRequestBody',
      'setSelectedShippingOption',
      'setShippingOptions'
    ]),
    sortServices(){
      var options = this.shippingOptions.sort(function(a, b) {
          return a.total_amount - b.total_amount;
      })
      this.setShippingOptions(options)
    },
    goToNewShipment () {
      this.setSelectedShippingOption(
        this.shippingOptions[this.selectedShippingOption]
      )
      this.$router.push('/shipment/new')
    },

    getTransitInterval (transitDays, carrierServiceName, isRemote) {
      if (!isRemote) {
        if (carrierServiceName === 'EXPRESS DOMESTIC 10:30') {
          return 'Día siguiente antes de las 10:30'
        } else if (carrierServiceName === 'EXPRESS DOMESTIC 12:00') {
          return 'Día siguiente antes de las 12:30'
        } else if (carrierServiceName === 'EXPRESS DOMESTIC') {
          return 'Día siguiente'
        } else if (carrierServiceName === 'EXPRESS') {
          return 'Día siguiente'
        } else if (carrierServiceName === 'ECOEXPRESS') {
          return 'Estándar 1 a 5 días'
        } else if (carrierServiceName === 'Standard Overnight') {
          return 'De 1 a 2 Días '
        } else if (carrierServiceName === 'FedEx Economy') {
          return 'De 1 a 4 Días'
        } else if (carrierServiceName === 'Priority Overnight') {
          return 'Día siguiente'
        } else {
          return 'Día siguiente'
        }  
      } else {
        return 'Entrega en un àrea Remota'
      }
    },
    /* getTransitInterval (transitDays) {
      if (transitDays >= 0 && transitDays <= 2) {
        return 'Estándar 1 a 2 días'
      } else if (transitDays >= 1 && transitDays <= 3) {
        return 'Estándar 1 a 3 días'
      } else if (transitDays >= 2 && transitDays <= 5) {
        return 'Estándar 2 a 5 días'
      }
    }, */
    getTransitIntervalAlt (transitDays) {
       if (transitDays >= 0 && transitDays <=1 ) {
        return '1-2'
      }else if (transitDays >= 1 && transitDays <=2 ) {
        return '1-2'
      } else if (transitDays >= 2 && transitDays <= 4) {
        return '2-4'
      } else if (transitDays >= 2 && transitDays <= 5) {
        return '2-5'
      } 
    },
    triggerPrimaryAction (selectedShippingOption) {
      this.$emit(
        'primary-action',
        this.visibleShipmentOptios[selectedShippingOption]
      )
    },
    triggerSecondaryAction (selectedShippingOption) {
      this.$emit('secondary-action')
    },
    filter (visibleCarriers, visibleShipmentSpeed) {
      let vc = []
      let vss = []

      if (!visibleCarriers.length) {
        vc = this.availableCarriers.map(c => c.value)
      } else {
        vc = visibleCarriers
      }

      if (!visibleShipmentSpeed.length) {
        vss = ['1-2', '1-3', '2-5']
      } else {
        vss = visibleShipmentSpeed
      }

      const op = this.shippingOptions.filter(sp => {
        if (
          vc.includes(sp.carrier) &&
          vss.includes(this.getTransitIntervalAlt(sp.total_transit_days))
        ) {
          return true
        }

        return false
      })

      this.visibleShipmentOptios = op
    },
    listAllShippingOptions () {
      this.sortServices()
      this.visibleShipmentOptions = this.shippingOptions
      let vc = []
      let vss = []

      if (!this.visibleCarriers.length) {
        vc = this.availableCarriers.map(c => c.value)
      } else {
        vc = this.visibleCarriers
      }

      if (!this.visibleShipmentSpeed.length) {
        vss = ['1-2', '1-3', '2-5']
      } else {
        vss = this.visibleShipmentSpeed
      }
      this.filter(vc, vss)
    }
  },
  computed: {
    ...mapGetters([
      'serviceProviders',
      'shippingOptions',
      'isLoadingShippingOptions'
    ])
  },
  created () {
    this.requestBody.origin_direction.country_code = this.origin.country_code
    this.requestBody.origin_direction.postal_code = this.origin.postal_code
    this.requestBody.origin_direction.city = this.origin.city
    this.requestBody.origin_direction.suburb = this.origin.colony

    this.requestBody.destination_direction.country_code = this.destination.country_code
    this.requestBody.destination_direction.postal_code = this.destination.postal_code
    this.requestBody.destination_direction.city = this.destination.city
    this.requestBody.destination_direction.suburb = this.destination.colony

    this.requestBody.parcels = this.parcels

    if (this.insurance.cost !== null) {
      this.requestBody['insured_value'] = this.insurance.cost
      this.requestBody['insured_value_currency'] = 'MXN'
    }

    this.requestBody.package_type = this.packageType

    this.setQuotingRequestBody(this.requestBody)
    this.quoting().then(response => {
      //console.log('response', response.data)
      this.listAllShippingOptions()
    })
  },
  components: {
    'navbar-dashboard': Navbar,
    'ph-icon': PhIcon
  },
}
</script>

<style scoped lang="scss">
@import "../assets/styles/app-tokens";
@import "../assets/styles/ew-components";

.ew-height { @include app-tokens; }

.ew-loading-indicator {
  min-height: 60vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ew-loading-indicator__inner { text-align: center; }
.ew-loading-indicator__text {
  margin-top: 1.5rem;
  font-family: var(--app-font);
  font-weight: 700;
  color: var(--app-navy);
  max-width: 22rem;
}

.ew-page__body { padding: 1.75rem 2rem 2.5rem; }

.ew-step-layout { display: grid; grid-template-columns: 1fr 16rem; align-items: start; gap: 1.5rem; }
@media (max-width: 960px) {
  .ew-step-layout { grid-template-columns: 1fr; }
  .ew-filters-aside { order: -1; }
}

.ew-carrier-list { display: flex; flex-direction: column; gap: 0.9rem; }
.ew-carrier-card { @include ew-carrier-card; }
.ew-carrier-card__logo { @include ew-carrier-card-logo; }
.ew-carrier-card__info { @include ew-carrier-card-info; }
.ew-carrier-card__price { @include ew-carrier-card-price; }

.ew-price-breakdown { min-width: 12rem; font-family: var(--app-font); font-size: 0.82rem; }
.ew-price-breakdown__row { display: flex; justify-content: space-between; gap: 1rem; padding: 0.2rem 0; color: var(--app-navy-secondary); }
.ew-price-breakdown__total { display: flex; justify-content: space-between; gap: 1rem; padding-top: 0.4rem; margin-top: 0.3rem; border-top: 1px solid var(--app-border); font-weight: 700; color: var(--app-navy); }

.ew-btn-primary { @include ew-btn-primary; }
.ew-btn-outline { @include ew-btn-outline; }
.ew-empty { @include ew-empty; }
.ew-empty__title { @include ew-empty-title; }
.ew-empty__text { @include ew-empty-text; }

.ew-wizard__actions { display: flex; justify-content: space-between; gap: 0.75rem; margin-top: 1rem; &--end { justify-content: flex-end; } }

.ew-card { @include ew-card; }
.ew-card-title { @include ew-card-title; }
.ew-filters-aside { padding: 1.25rem; }
.ew-filters-aside__title--spaced { margin-top: 1.5rem; }
.ew-filter-check { @include ew-filter-check; }
</style>



// WEBPACK FOOTER //
// src/components/ServiceProviderSelector.vue